__turbopack_context__.v({
  "personInfo": "Testimonial-module__-IISGa__personInfo",
  "personPosition": "Testimonial-module__-IISGa__personPosition",
  "testimonial": "Testimonial-module__-IISGa__testimonial",
  "testimonialText": "Testimonial-module__-IISGa__testimonialText",
});
